<template>
  <div>
    <v-row>
      <v-col md="3">
        <v-text-field
          hide-details="auto"
          type="date"
          solo
          flat
          background-color="grey lighten-4"
          v-model="searchParams.date_start"
          label="Data Inicial"
        />
      </v-col>
      <v-col md="3">
        <v-text-field
          hide-details="auto"
          type="date"
          solo
          flat
          background-color="grey lighten-4"
          v-model="searchParams.date_end"
          label="Data Final"
        />
      </v-col>
      <v-col md="4">
        <CompanySelect
          chips
          multiple
          v-model="searchParams.company_id"
          :item-value="(val) => val.id"
          :itemText="(val) => val.short_name"
          solo
          flat
          background-color="grey lighten-4"
          :dense="false"
        />
      </v-col>
      <v-col md="2">
        <v-btn
          color="primary"
          block
          large
          @click="select()"
          :loading="isLoading"
        >
          <v-icon left>mdi-magnify</v-icon>
          Pesquisar
        </v-btn>
      </v-col>
    </v-row>

    <v-row class="mt-10 justify-space-between">
      <v-col>
        <v-card elevation="0" class="fill-height grey lighten-4">
          <v-card-text class="d-flex align-center justify-space-between">
            <div>
              Total das Vendas
              <br />
              <b class="text-h4">{{ $format.decimal(netPriceCashTotalSum) }}</b>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col>
        <v-card elevation="0" class="fill-height grey lighten-4">
          <v-card-text class="d-flex align-center justify-space-between">
            <div>
              Total das Compras
              <br />
              <b class="text-h4">
                {{ $format.decimal(purchaseTotalSum) }}
              </b>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col>
        <v-card outlined color="primary" elevation="0" dark class="fill-height">
          <v-card-text class="d-flex align-center justify-space-between">
            <div>
              Total do Lucro
              <br />
              <b class="text-h4">{{ $format.decimal(profitTotalSum) }}</b>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row class="mt-6">
      <v-col>
        <v-card flat color="grey lighten-4">
          <v-card-title class="d-flex justify-space-between mb-4 pt-5">
            <span class="text-subtitle-1">
              Vendas vs Compras por Marca
            </span>
            <v-btn color="success" @click="handleExport" small class="px-4">
              <v-icon left>mdi-microsoft-excel</v-icon>
              Exportar
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-data-table
              class="grey lighten-4"
              :headers="headers"
              :items="brands"
              hide-default-footer
              :items-per-page="-1"
              disable-sort
            >
              <template v-slot:item.brand_name="{ item }">
                {{ item.brand_name || "Sem marca" }}
              </template>

              <template v-slot:item.quantity="{ item }">
                {{ $format.decimal(item.quantity) }}
              </template>

              <template v-slot:item.net_price_cash_total_sum="{ item }">
                R$ {{ $format.decimal(item.net_price_cash_total_sum) }}
              </template>

              <template v-slot:item.purchase_total="{ item }">
                R$ {{ $format.decimal(item.purchase_total) }}
              </template>

              <template v-slot:item.profit_sum="{ item }">
                R$ {{ $format.decimal(item.profit_sum) }}
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import CompanySelect from "@/components/company/ui/CompanySelect.vue";
import { format, startOfMonth } from "date-fns";

export default {
  components: {
    CompanySelect,
  },

  data() {
    return {
      headers: [
        { text: "Marca", value: "brand_name", align: "start" },
        // { text: "Quantidade", value: "quantity", align: "end" },
        {
          text: "Total Vendas",
          value: "net_price_cash_total_sum",
          align: "end",
        },
        { text: "Total Compras", value: "purchase_total", align: "end" },
        { text: "Lucro", value: "profit_sum", align: "end" },
      ],

      brands: [],

      searchParams: {
        company_id: [],
        date_start: format(startOfMonth(new Date()), "yyyy-MM-dd"),
        date_end: format(new Date(), "yyyy-MM-dd"),
      },

      isLoading: false,
    };
  },

  mounted() {
    this.select();
  },

  computed: {
    netPriceCashTotalSum() {
      return this.$calc.sum(this.brands, "net_price_cash_total_sum");
    },

    purchaseTotalSum() {
      return this.$calc.sum(this.brands, "purchase_total");
    },

    profitTotalSum() {
      return this.$calc.sum(this.brands, "profit_sum");
    },
  },

  methods: {
    async select() {
      this.isLoading = true;

      try {
        const response = await this.$http.index(
          "sale/sale-vs-purchase",
          this.searchParams
        );

        this.brands = response.filter(
          (item) =>
            Number(item.net_price_cash_total_sum) !== 0 ||
            Number(item.purchase_total) !== 0
        );
        
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },

    handleExport() {
      this.$http
        .download("sale/sale-vs-purchase-export", this.searchParams)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `Vendas_vs_Compras_${this.searchParams.date_start}.xlsx`
          );
          document.body.appendChild(link);
          link.click();
          this.$loading.finish();
        })
        .catch((error) => {
          console.log(error);
          this.$loading.finish();
        });
    },
  },
};
</script>
